import { GiftIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import {
  getLastSeenAt,
  noteLatestPublishedAt,
  useMarkUpdatesSeen,
} from '../hooks'
import type { Update } from '../types'
import { UpdateCard } from './UpdateCard'

export const UpdatesList = ({ updates }: { updates: Update[] }) => {
  const markSeen = useMarkUpdatesSeen()
  const [seenAtOnEnter] = useState(getLastSeenAt)

  useEffect(() => {
    const newest = updates[0]?.publishedAt ?? null
    noteLatestPublishedAt(newest)
    markSeen(newest)
  }, [updates, markSeen])

  return (
    <div className="mx-auto max-w-3xl space-y-8">
      <header className="flex items-start gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand/10 text-brand">
          <GiftIcon className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-pretty text-2xl font-bold tracking-tight text-foreground">
            Updates
          </h1>
          <p className="text-pretty text-sm text-blue-6">
            New features, improvements, and fixes across CounselPro.
          </p>
        </div>
      </header>

      {updates.length === 0 ? (
        <p className="text-pretty text-sm text-blue-6">
          No updates yet. Check back soon.
        </p>
      ) : (
        <div className="space-y-3">
          {updates.map((update) => (
            <UpdateCard
              key={update.id}
              update={update}
              isNew={!seenAtOnEnter || update.publishedAt > seenAtOnEnter}
            />
          ))}
        </div>
      )}
    </div>
  )
}
